<app-header></app-header>
<ngx-spinner bdColor="rgba(51,51,51,0.8)" size="medium" color="#fff" loadingText="Loading..." type="ball-scale-multiple">
</ngx-spinner>
<section>
    <div class="row no-mar-lr mar-tb-20">
        <div class="col-md-5">
            <span class="dta_title">{{'Daily View' | translate}}</span>
        </div>
        <div class="col-md-7 pad-top-10 text-right">
            <a href="#/poFCMonthly" class="has-link">{{'Monthly View' | translate}}</a> |
            <a href="#/poFCJun" class="has-link">{{'Jun View' | translate}}</a> |
            <a href="#/poFCDaily" class="has-link">{{'Daily View' | translate}}</a> |
            <a href="#/poSummary" class="has-link">{{'Package Data Availability' | translate}}</a> |
            <a href="#/poDashboard" class="has-link">Back&nbsp;
                <i class="fa fa-reply" aria-hidden="true"></i>
            </a>
        </div>
    </div>

    <ul class="nav nav-tabs pad-top-40" role="tablist">
        <li class="nav-item" (click)="resetDD()">
            <a class="nav-link active" data-toggle="tab" href="#tableView" role="tab" #unlistDPNav>{{'Table View' |
                translate}}</a>
        </li>
        <li class="nav-item" (click)="resetDD()">
            <a class="nav-link" data-toggle="tab" href="#graphView" role="tab" #createDPNav>{{'Graph View' |
                translate}}</a>
        </li>
    </ul>

    <div class="tab-content">
        <div class="tab-pane pad-btm-30 active" id="tableView" #unlistDPPane>
            <section class="part_search_bar">
                <div class="row no-mar-lr">
                    <div class="col-md-1 pad-top-30 text-right">{{'Spec' | translate}}.</div>
                    <div class="col-md-2 pad-top-30">
                        <select [(ngModel)]="name" name="Select" class="form-control">
                            <option *ngFor="let n of names" [ngValue]="n">{{n}}</option>
                        </select>
                    </div>

                    <div class="col-md-3 pad-top-30">
                        <div class="row">
                            <div class="col-md-5 text-right pad-top-5">
                                {{'SUPPLIERCODE' | translate}} &nbsp;&nbsp;&nbsp;
                            </div>
                            <div class="col-md-5">
                                <ng-multiselect-dropdown *ngIf="suppCodeList" #suppliercodeTbl="ngModel" name="suppliercodetbl"
                                [(ngModel)]="suppCodeTbl" [settings]="dropdownSettings" [data]="suppCodeList" 
                                    (onSelect)="onSupplierCodeSelect($event)" (onDeSelect)="OnSupplierCodeDeSelect($event)"
                                    (onSelectAll)="onSupplierCodeSelectAll($event)" (onDeSelectAll)="onSupplierCodeDeSelectAll($event)">
                                </ng-multiselect-dropdown>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-5 pad-top-30">
                        <div class="row">
                            <div class="col-md-5 text-right pad-top-5">
                                {{'Location Code' | translate}} &nbsp;&nbsp;&nbsp;
                            </div>
                            <div class="col-md-5">
                                <ng-multiselect-dropdown *ngIf="locCodeList" #locationcodeTbl="ngModel" name="locationcodeTbl"
                                [(ngModel)]="locCodeTbl" [settings]="dropdownSettings"   [data]="locCodeList">
                                </ng-multiselect-dropdown>
                            </div>
                        </div>

                    </div>
                    <div class="col-md-1 pad-top-30">
                        <button class="btn btn btn-dark" (click)="onChangeTable(config, $event)">{{'Display' |
                            translate}}</button>
                    </div>
                </div>
            </section>
            <div class="row no-mar-lr mar-top-50">
                <div class="col-md-12">
                    <div class="row">
                        <div class="col-md-12 text-right">
                            <i class="fa fa-info-circle" aria-hidden="true" pTooltip="{{'Please choose Specification, atleast 1 Supplier code / Location to enable export' | translate}}"
                                tooltipPosition="top"></i>
                            <button [disabled]="!enableExport" type="button" class="col-md-1 btn btn-dark" (click)="exportTable()">{{'Export'
                                | translate}}</button>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-md-6" *ngIf="dailyView !== undefined && dailyView.response !== undefined && daywisearraylength>0">
                            <p class="pt21">{{'Cycle' | translate}}:
                                <strong>{{dailyView.response.content[0].forcast1Cycle}}</strong>
                                , {{'Month' | translate}}:
                                <strong>{{dailyView.response.content[0].forcast1Month}}</strong>
                                , {{'Year' | translate}}:
                                <strong>{{dailyView.response.content[0].forcast1Yr}}</strong>
                                &nbsp;
                                <b> to </b>&nbsp; {{'Cycle' | translate}}:
                                <strong>{{dailyView.response.content[0].forcast2Cycle}}</strong>
                                , {{'Month' | translate}}:
                                <strong>{{dailyView.response.content[0].forcast2Month}}</strong>
                                , {{'Year' | translate}}:
                                <strong>{{dailyView.response.content[0].forcast2Yr}}</strong>
                            </p>

                            <p class="text-danger"><i>Note:
                                Volume=
                                <strong> mm<sup>3</sup></strong>
                                , Weight=
                                <strong>kg</strong></i>
                            </p>
                        </div>
                        <div class="col-md-6">
                            <pagination *ngIf="config.paging" class="pagination-sm pull-right pad-top-10" [(ngModel)]="page"
                                [totalItems]="length" [itemsPerPage]="itemsPerPage" [maxSize]="maxSize" [boundaryLinks]="true"
                                [rotate]="false" (pageChanged)="onChangeTable(config, $event)" (numPages)="numPages = $event">
                            </pagination>
                        </div>
                    </div>
                    <table class="table table-bordered text-centered" *ngIf="dailyView.response !== undefined && daywisearraylength>0">
                        <tr class="bg-gray">
                            <th>{{'Supplier' | translate}}</th>
                            <th>{{'Part No' | translate}}.</th>
                            <th>{{'Location' | translate}}</th>
                            <th>{{'DELIVERYPOINT' | translate}}</th>
                            <th>{{'LINENUMBER' | translate}}</th>
                            <th>{{'Spec' | translate}}</th>
                            <th *ngFor="let date  of dailyView.response.content[0].daywiseDetails">
                                {{date.day | date:'yyyy-MM-dd EEE'}}</th>
                        </tr>
                        <tbody *ngFor="let data of dailyView.response.content; let i = index">
                            <tr>
                                <th rowspan="5">{{dailyView.response.content[i].supplierCode}}</th>
                                <th class="font-normal" rowspan="5">{{dailyView.response.content[i].partNumber}}</th>
                                <th class="font-normal" rowspan="5">{{dailyView.response.content[i].plantName}}</th>
                                <th class="font-normal" rowspan="5">{{dailyView.response.content[i].deliveryPoint}}</th>
                                <th class="font-normal" rowspan="5">{{dailyView.response.content[i].lineNumber}}</th>
                            </tr>
                            <tr *ngIf="showSepFilter == 'All' || showSepFilter == 'Quantity'">
                                <th class="font-normal">{{'Quantity' | translate}}</th>
                                <td class="font-normal" *ngFor="let datewiseQty of dailyView.response.content[i].daywiseDetails; let k = index">
                                    {{dailyView.response.content[i].daywiseDetails[k].dayQuantity}}</td>
                            </tr>
                            <tr *ngIf="showSepFilter == 'All' || showSepFilter == 'Weight'">
                                <th class="font-normal">{{'Weight' | translate}}</th>
                                <td class="font-normal" *ngFor="let datewiseQty of dailyView.response.content[i].daywiseDetails; let k = index">
                                    {{dailyView.response.content[i].daywiseDetails[k].dayWeight}}</td>
                            </tr>
                            <tr *ngIf="showSepFilter == 'All' || showSepFilter == 'Volume'">
                                <th class="font-normal">{{'Volume' | translate}}</th>
                                <td class="font-normal" *ngFor="let datewiseQty of dailyView.response.content[i].daywiseDetails; let k = index">
                                    {{dailyView.response.content[i].daywiseDetails[k].dayVolume}}</td>
                            </tr>
                            <tr *ngIf="showSepFilter == 'All' || showSepFilter == 'No. Of Boxes'">
                                <th class="font-normal">
                                    <div class="fullRowNoborder" style="width: 110px;">No. of Boxes</div>
                                </th>
                                <td class="font-normal" *ngFor="let datewiseQty of dailyView.response.content[i].daywiseDetails; let k = index">
                                    {{dailyView.response.content[i].daywiseDetails[k].dayNumberOfBox}}</td>
                            </tr>
                        </tbody>
                    </table>
                    <div class="noRecords" *ngIf="dailyView.response.content.length == 0"> {{'No Records Found' |
                        translate}}! </div>
                </div>
                <div class="col-md-3">
                </div>
            </div>
        </div>
        <div class="tab-pane pad-btm-30" id="graphView" #createDPPane>
            <section class="part_search_bar">
                <div class="row no-mar-lr">
                    <div class="col-md-1"></div>
                    <div class="col-md-3 pad-top-30">
                        <div class="row">
                            <div class="col-md-5 text-right pad-top-5">
                                {{'SUPPLIERCODE' | translate}} &nbsp;&nbsp;&nbsp;
                            </div>
                            <div class="col-md-5">
                                <p-dropdown [options]="graphSuppDD" [(ngModel)]="supPoint" [filter]="true" [style]="{'width':'100%'}"
                                    (onChange)="onGraphSuppSel($event)" placeholder="Select Supplier Code"></p-dropdown>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-4 pad-top-30">
                        <div class="row">
                            <div class="col-md-5 text-right pad-top-5">
                                {{'Location Code' | translate}} &nbsp;&nbsp;&nbsp;
                            </div>
                            <div class="col-md-5">
                                <ng-multiselect-dropdown *ngIf="locDD" #locationcodeGrph="ngModel" name="locationcodeGrph"
                                [(ngModel)]="locCode" [settings]="graphLocStg"  [data]="locDD">
                                </ng-multiselect-dropdown>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-3 pad-top-30">
                        <button class="btn btn btn-dark" (click)="showGraphData()" [disabled]="graphDispBtn">{{'Display'
                            | translate}}</button>
                    </div>
                </div>
            </section>
            <section *ngIf="QuantityChartData.length > 0 || WeightChartData.length > 0 ||  VolumeChartData.length > 0">
                <div class="col-md-6" *ngIf="dailyView !== undefined && dailyView.response !== undefined">
                    <p class="pt21">{{'Cycle' | translate}}:
                        <strong>{{dailyView.response.content[0].forcast1Cycle}}</strong>
                        , {{'Month' | translate}}:
                        <strong>{{dailyView.response.content[0].forcast1Month}}</strong>
                        , {{'Year' | translate}}:
                        <strong>{{dailyView.response.content[0].forcast1Yr}}</strong>
                        &nbsp;
                        <b> to </b>&nbsp; {{'Cycle' | translate}}:
                        <strong>{{dailyView.response.content[0].forcast2Cycle}}</strong>
                        , {{'Month' | translate}}:
                        <strong>{{dailyView.response.content[0].forcast2Month}}</strong>
                        , {{'Year' | translate}}:
                        <strong>{{dailyView.response.content[0].forcast2Yr}}</strong>
                    </p>
                </div>
                <div class="row">
                    <div class="offset-md-2 col-md-4 pt21" *ngIf="resultData != undefined">
                        <strong>{{'SUPPNAME[Eng]' | translate}} : {{resultData.supplierNameEN}}</strong>
                    </div>
                    <div class="col-md-4 pt21" *ngIf="resultData != undefined">
                        <strong>{{'SUPPNAME[Jap]' | translate}}: {{resultData.supplierNameJP}}</strong>
                    </div>
                </div>
            </section>
            <div class="no-mar-lr container">
                <div class="row">
                    <div class="col-md-6">
                        <div class="panel panel-default mar-top-40">
                            <div class="panel-heading bgWhite">
                                <b class="panelTitle">{{'Volume' | translate}}(m3)</b>
                            </div>
                            <div class="panel-body">
                                <div *ngIf="VolumeChartData.length > 0">
                                    <canvas *ngIf="VolumeChartData" baseChart [datasets]="VolumeChartData" [labels]="dailyChartLabels"
                                        [options]="stackChartOpt" [legend]="barChartLegend" [colors]="lineChartColors"
                                        [chartType]="barChartType">
                                    </canvas>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-6 mar-top-40">
                        <table class="table table-bordered">
                            <thead class="bg-gray">
                                <tr>
                                    <th class="text-center">{{'Location' | translate}}</th>
                                    <th class="text-center" *ngFor="let date of dailyGraphDates">{{date}}</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr *ngFor="let data of dailyGraphData">
                                    <td class="text-center">{{data.locationName}}</td>
                                    <td class="text-center" *ngFor="let item of data.totalLocationWiseSumDayDetails">{{item.sumVolume
                                        | number : '1.2-2'}}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-6">
                        <div class="panel panel-default mar-top-40">
                            <div class="panel-heading bgWhite">
                                <b class="panelTitle">{{'Weight' | translate}}(Kg)</b>
                            </div>
                            <div class="panel-body">
                                <div *ngIf="WeightChartData.length > 0">
                                    <canvas *ngIf="WeightChartData" baseChart [datasets]="WeightChartData" [labels]="dailyChartLabels"
                                        [options]="stackChartOpt" [legend]="barChartLegend" [colors]="lineChartColors"
                                        [chartType]="barChartType">
                                    </canvas>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-6 mar-top-40">
                        <table class="table table-bordered">
                            <thead class="bg-gray">
                                <tr>
                                    <th class="text-center">{{'Location' | translate}}</th>
                                    <th class="text-center" *ngFor="let date of dailyGraphDates">{{date}}</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr *ngFor="let data of dailyGraphData">
                                    <td class="text-center">{{data.locationName}}</td>
                                    <td class="text-center" *ngFor="let item of data.totalLocationWiseSumDayDetails">{{item.sumWeight
                                        | number : '1.2-2'}}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-6">
                        <div class="panel panel-default mar-top-40">
                            <div class="panel-heading bgWhite">
                                <b class="panelTitle">{{'Quantity' | translate}}</b>
                            </div>
                            <div class="panel-body">
                                <div>
                                    <div style="display: block">
                                        <div *ngIf="QuantityChartData.length > 0">
                                            <canvas *ngIf="QuantityChartData" baseChart [datasets]="QuantityChartData"
                                                [labels]="dailyChartLabels" [options]="stackChartOpt" [legend]="barChartLegend"
                                                [colors]="lineChartColors" [chartType]="barChartType">
                                            </canvas>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-6 mar-top-40">
                        <table class="table table-bordered">
                            <thead class="bg-gray">
                                <tr>
                                    <th class="text-center">{{'Location' | translate}}</th>
                                    <th class="text-center" *ngFor="let date of dailyGraphDates">{{date}}</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr *ngFor="let data of dailyGraphData">
                                    <td class="text-center">{{data.locationName}}</td>
                                    <td class="text-center" *ngFor="let item of data.totalLocationWiseSumDayDetails">{{item.sumQuantity
                                        | number : '1.2-2'}}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    </div>


</section>